// @flow
import styled from 'styled-components';

export const StyledSpan = styled.span`font-size: 0.5em;`;

export const BulbFlipperWrapper = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
`;



// WEBPACK FOOTER //
// ./src/components/bulbs/styles.js